/** Lets any screen ask the project browser pane to open a URL, even before the pane is mounted or connected. */
export const browserOpenBus = new EventTarget();
let pending: string | null = null;

export function requestBrowserOpen(url: string) {
  pending = url;
  browserOpenBus.dispatchEvent(new CustomEvent("open", { detail: url }));
}

/** Returns and clears the URL waiting to be opened, if any. */
export function takePendingBrowserOpen(): string | null {
  const u = pending;
  pending = null;
  return u;
}
